(function () {
  function initClinicalReview(root) {
    if (root.hasAttribute("data-clinical-review-ready")) return;
    root.setAttribute("data-clinical-review-ready", "true");
    var bodyEl = root.querySelector("[data-clinical-review-body]");
    var toggleBtn = root.querySelector("[data-clinical-review-toggle]");
    var labelEl = root.querySelector("[data-clinical-review-label]");
    var iconEl = root.querySelector("[data-clinical-review-icon]");
    if (!bodyEl || !toggleBtn) return;

    function applyExpanded(expanded) {
      root.setAttribute("data-expanded", expanded ? "true" : "false");
      toggleBtn.setAttribute("aria-expanded", expanded ? "true" : "false");
      if (labelEl) {
        labelEl.textContent = expanded ? "Show less" : "Read detailed notes";
      }
      if (iconEl) {
        iconEl.textContent = expanded ? "expand_less" : "expand_more";
      }
    }
    toggleBtn.addEventListener("click", function () {
      var on = root.getAttribute("data-expanded") === "true";
      applyExpanded(!on);
    });
    applyExpanded(false);
  }

  document.querySelectorAll("[data-clinical-review]").forEach(initClinicalReview);
})();
